var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var BannerIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 68,
    glyphHeight: 34
  }), React.createElement("path", {
    d: "M67.3913 33.6956H0.608696V0.304321H67.3913V33.6956ZM4.78261 29.5217H63.2174V4.47823H4.78261V29.5217ZM55.4957 18.8782L40.887 7.19128C40.2609 6.77389 39.8435 6.56519 39.2174 6.56519C38.5913 6.56519 38.1739 6.56519 37.5478 6.98258L22.9391 18.6695L16.2609 13.4521C15.4261 12.8261 14.1739 12.8261 13.3391 13.4521L6.86956 18.8782V27.4348H34H44.4348H61.1304V23.2608L55.4957 18.8782ZM56.9565 6.56519C54.6609 6.56519 52.7826 8.44345 52.7826 10.7391C52.7826 13.0348 54.6609 14.913 56.9565 14.913C59.2522 14.913 61.1304 13.0348 61.1304 10.7391C61.1304 8.44345 59.2522 6.56519 56.9565 6.56519Z",
    fill: "black"
  }));
};
export var BannerIconGlyph = function (props) {
  return React.createElement(BannerIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};